<template>
    <div>
        <!--生涯课堂-->
        <el-container>
            <el-main  style="min-height:calc(100vh - 340px);position: relative;">
                <div v-show="!contentLoading&&this.listZcList.length>0">
                    <div  style="min-height:calc(100vh - 360px);"   >
                        <ul class="studyItem">
                            <li class="clearfix" v-for="item in listZcList" :key="item.albumId">
                                <a target="_blank" @click="selectAlbum(item.albumId)" style="cursor: pointer">
                                    <img v-lazy="item.coverImg" width="298" height="168" alt=""  class="lazy fl" style="display: block;">
                                </a>
                                <div class="intro">
                                    <div>
                                        <a target="_blank" @click="selectAlbum(item.albumId)" style="cursor: pointer;color:rgba(0, 0, 0, 0.85);font-weight:bold;">{{item.name}}</a>
                                    </div>
                                    <p class="teacher mt">
                                            <span class="grade">年级：
                                                <span v-for="itemGrade in item.grades" class="remmber" :key="itemGrade">
                                                    {{itemGrade}} /
                                                </span>
                                            </span>
                                        <!--                                            <span class="completeStatus">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;状态：{{item.status}}</span>-->
                                    </p>
                                    <div class="mt" style="color: rgba(0, 0, 0, 0.65);">
                                        {{item.description}}
                                    </div>
                                    <p class="status mt">
                                        <span class="text-medium-secondary">更新讲数:</span>
                                        <span class="  remmber">{{item.videoCount}}</span>
                                        <span class="space mrgL15 mrgR15">|</span>
                                        <span class="digital"><span class="text-medium-secondary">播放:</span> <span class="remmber">{{item.playTimes}}</span></span>
                                        <span class="space mrgL15 mrgR15">|</span>
                                        <!-- <span class="digital">0</span>%好评<span class="space mrgL15 mrgR15">|</span> -->
                                        <span class="digital"><span class="text-medium-secondary">评分：</span>
                                                <span class="remmber">
                                                    {{item.score}}
                                                </span></span>分
                                        <span class="digital"></span>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="  padding-y" >
                        <el-pagination
                                :hide-on-single-page="true"
                                class="text-center"
                                @current-change="handleCurrentChange"
                                :current-page.sync="pIndex"
                                :page-size="10"
                                layout="prev, pager, next, jumper"
                                :total="totalItem">
                        </el-pagination>
                    </div>
                </div>
                <empty v-show="!contentLoading&&this.listZcList.length<1" class="margin-top"></empty>
                <loading :show="contentLoading"></loading>
            </el-main>
        </el-container>
        <common-target-router @clearHref="clearHref" :get-location="getLocation"></common-target-router>
    </div>
</template>
<script>
    import {courseSelectPolicy} from "../../../config";

    export default {
        name: "subjectTips",
        data(){
            return{
                getLocation:'',
                contentLoading:false,
                listZcList:[],
                totalItem:0,
                pIndex:1
            }
        },
        mounted(){
            this.contentLoading=true;
            this.optionSubject();
        },
        methods:{
            clearHref(){
                this.getLocation='';
            },
            handleCurrentChange(){
                this.contentLoading=true;
                this.optionSubject();
            },
            async optionSubject(){
                let result=await courseSelectPolicy('57f07a6b485c23350ab16b2aebaf4e69',this.pIndex,10);
                if(result.status){
                    this.totalItem=result.data.totalRecords;
                    this.listZcList=result.data.data;
                    console.log(result.data);
                    this.contentLoading=false;
                }else{
                    this.contentLoading=false;
                }
            },
            selectAlbum(val){
                const {href} = this.$router.resolve(
                    {path:'/videoPlayer',
                        query:{albumId:val,type:'生涯'}});
                this.getLocation=href;
            },
        }
    }
</script>

<style scoped>

</style>